Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = void 0;
var _reactNative = require("react-native-web");
var useStyles = exports.useStyles = function useStyles(_ref) {
  var textStyle = _ref.textStyle,
    sharedStyles = _ref.sharedStyles;
  var paragraph = sharedStyles.paragraph,
    textColor = sharedStyles.textColor;
  var _ratio = 0.8;
  var _textStyle = Object.assign({}, paragraph, textStyle);
  var styles = _reactNative.StyleSheet.create({
    small: {
      fontFamily: paragraph.fontFamily,
      color: textColor || paragraph.color,
      fontSize: _reactNative.Platform.OS === 'web' ? "calc(".concat(_ratio, " * ").concat(_textStyle.fontSize, ")") : _ratio * _textStyle.fontSize,
      lineHeight: _reactNative.Platform.OS === 'web' ? "calc(".concat(_ratio, " * ").concat(_textStyle.lineHeight, ")") : _ratio * _textStyle.lineHeight
    }
  });
  return {
    styles: styles
  };
};